import {
  Action,
  ActionType,
  IPatientCSVResponse,
} from "models/patients/downloadCSV";
import createReducer from "redux/createReducer";

export interface PatientCSVReducerType {
  loading: boolean;
  error?: string;
  patientCSVResponse?: IPatientCSVResponse;
}

const defaultState: PatientCSVReducerType = {
  loading: false,
  error: undefined,
  patientCSVResponse: undefined,
};

export const patientCSVReducer = createReducer<PatientCSVReducerType>(
  defaultState,
  {
    [ActionType.DOWNLOAD_PATIENT_CSV](state: PatientCSVReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DOWNLOAD_PATIENT_CSV_ERROR](
      state: PatientCSVReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        patientCSVResponse: undefined,
      };
    },

    [ActionType.DOWNLOAD_PATIENT_CSV_SUCCESS](
      state: PatientCSVReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        patientCSVResponse: action.payload,
      };
    },

    [ActionType.DOWNLOAD_PATIENT_CSV_RESET](state: PatientCSVReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        patientCSVResponse: undefined,
      };
    },
  }
);
